import { Component, OnInit } from '@angular/core';
import { ApiService, UserInfo } from '../../services/api.service'
import { MenuService } from '../../services/menu.service'
import { CurrencyService } from '../../services/currency.service'
import { AccountType } from '../../interfaces/api/AccountType'
import { CosentinoSvgComponent } from '@components/cosentino-svg/cosentino-svg.component'
import { ButtonComponent } from '@components/button/button.component'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { CommonModule, NgForOf } from '@angular/common'
import { HeaderComponent } from '@components/header/header.component';
import { GenericHeaderComponent } from '@components/generic-header/generic-header.component';
import { TableComponent } from '@components/table/table.component';
import { PaginationComponent } from '@components/pagination/pagination.component';
import { ColumnConfig, ColumnFormat } from '@components/table/table.component'
import { AlertComponent } from '@components/alert/alert.component';
import { SelectComponent } from '@components/select/select.component';
import { SelectValue } from 'app/interfaces/select-value.interface';
import { InputComponent } from '@components/input/input.component';
import { ConfirmModalComponent } from '@components/confirm-modal/confirm-modal.component'
import { MatTooltipModule } from '@angular/material/tooltip'

interface RequestedCommissionProjectDetail {
    projectName: string
    poNumbers: string[]
    bonusAmount: number
}

interface RequestedCommissionRow {
    id: string
    status: string
    statusLabel?: string
    projectName: string
    poNumber: string
    requestedDate: string
    memberName: string
    amount: string
    invoiceUrl: string | null
    currencyIsoCode: string
    projectDetails: RequestedCommissionProjectDetail[]
}

@Component({
    standalone: true,
    selector: 'app-commissions',
    templateUrl: './commissions.component.html',
    styleUrls: ['./commissions.component.scss'],
    imports: [
        CosentinoSvgComponent,
        ButtonComponent,
        TranslateModule,
        NgForOf,
        HeaderComponent,
        CommonModule,
        GenericHeaderComponent,
        TableComponent,
        PaginationComponent,
        AlertComponent,
        SelectComponent,
        InputComponent,
        ConfirmModalComponent,
        MatTooltipModule
    ],
})
export class CommissionsComponent implements OnInit {
    userInfo: UserInfo
    tab: string = 'TO_REQUEST'
    public currentPage: number = 0
    public totalPages: number = 0
    private readonly pageSize: number = 4
    public today = new Date()
    public totalPendingAmount: number = 0
    pendingCommissionsColumns: ColumnConfig[] = [
        { key: 'id', visible: false },
        { key: 'projectName', header: this.translateService.instant('commissions.project_name') },
        { key: 'poNumber', header: this.translateService.instant('commissions.reference') },
        { key: 'sapBonusExpiredDate', header: this.translateService.instant('commissions.expiration_date') },
        { key: 'automaticInvoice', visible: false },
        { key: 'memberName', header: this.translateService.instant('commissions.desginer') },
        { key: 'amount', header: this.translateService.instant('commissions.amount') },
    ]
    requestedCommissionsColumns: ColumnConfig[] = [
        { key: 'status', header: this.translateService.instant('commissions.status') },
        { key: 'projectName', header: this.translateService.instant('commissions.project_name') },
        { key: 'poNumber', header: this.translateService.instant('commissions.reference') },
        { key: 'requestedDate', header: this.translateService.instant('commissions.requested_date') },
        { key: 'memberName', header: this.translateService.instant('commissions.desginer') },
        { key: 'amount', header: this.translateService.instant('commissions.amount') },
        { key: 'invoiceUrl', header: this.translateService.instant('commissions.invoice'), format: 'link' },
    ]
    rowActions = [{ label: 'partners.table.contact-data', action: 'contact' }]

    selectedCommissions: any[] = []

    availableTypes: SelectValue[] = [
        { label: this.translateService.instant('commissions.with_automatic_invoice'), value: 'AUTOMATIC_INVOICE', id: 'AUTOMATIC_INVOICE' },
        { label: this.translateService.instant('commissions.with_manual_invoice'), value: 'MANUAL_INVOICE', id: 'MANUAL_INVOICE' },
    ]
    selectedValue: SelectValue = this.availableTypes[0]
    selectedInvoiceType: 'AUTOMATIC_INVOICE' | 'MANUAL_INVOICE' = 'AUTOMATIC_INVOICE'
    lastRequestedInvoiceType: 'AUTOMATIC_INVOICE' | 'MANUAL_INVOICE' = 'AUTOMATIC_INVOICE'
    isRequestResultModalOpen = false
    pendingCommissionsOriginalData: any[] = []
    pendingCommissionsFilteredData: any[] = []
    pendingCommissionsData: any[] = //initialize mock data
        [
            // { projectName: 'Project A', expirationDate: '2024-12-31', designer: 'John Doe', Amount: 1500 },
            // { projectName: 'Project B', expirationDate: '2025-01-15', designer: 'Jane Smith', Amount: 2500 },
            // { projectName: 'Project C', expirationDate: '2025-02-20', designer: 'Mike Johnson', Amount: 3000 },
        ]
    requestedCommissionsOriginalData: any[] = []
    requestedCommissionsMappedData: RequestedCommissionRow[] = []
    requestedCommissionsData: RequestedCommissionRow[] = [
        // { projectName: 'Project X', expirationDate: '2024-11-30', designer: 'Alice Brown', Amount: 2000 },
        // { projectName: 'Project Y', expirationDate: '2025-03-10', designer: 'Bob White', Amount: 3500 },
    ]
    private readonly useRequestedCommissionsDummyData = true
    expandedRequestedCommissionIds = new Set<string>()
    expandedPendingCommissionIds = new Set<string>()
    constructor(private api: ApiService, protected menuService: MenuService, private translateService: TranslateService, private currencyService: CurrencyService) {}

    private readonly pendingCommissionsDummyData = [
        {
            "id": "aAzJW0000003rCf0AI",
            "projectId": "0067T000006nLIbQAM",
            "projectName": "DK / Fachada Ventilada / Edifício AltaVista 16 / CIVI4 / BLK ARQUITETURA / KOMAT",
            "createdDate": "2026-01-16T10:34:34.000+0000",
            "memberName": "marta Caetano",
            "status": "Created_from_SAP",
            "statusLabel": "Created_from_SAP",
            "designerOrderAmount": null,
            "amount": 201.36,
            "amountFront": 201.36,
            "poNumber": 4287052,
            "projectNameFront": "DK / Fachada Ventilada / Edifício AltaVista 16 / CIVI4 / BLK ARQUITETURA / KOMAT",
            "createdByName": "Integration User",
            "invoiceNumber": null,
            "currencyIsoCode": "EUR",
            "invoiceUrl": null,
            "projectAccountId": "0010X00004ool0ZQAQ",
            "projectAccountName": "Komat SA",
            "projectAccountOwnerLanguage": "es",
            "projectAccountOwnerEmail": "rbatista@cosentino.com.invalid",
            "sapBonusAmountInvoice": 0.0,
            "sapBonusAmount": 201.36,
            "sapBonusExpiredDate": "2026-07-16",
            "accountId": "0017T00000Ndp4CQAR",
            "automaticInvoice": true
        },
        {
            "id": "aAzJW0000003rCg0AI",
            "projectId": "0067T000006nLIcQAM",
            "projectName": "ES / Encimera / Vivienda Costa Azul 8 / VML2 / ESTUDIO NOGAL / ARKEM",
            "createdDate": "2026-02-04T09:12:18.000+0000",
            "memberName": "lucia Romero",
            "status": "Created_from_SAP",
            "statusLabel": "Created_from_SAP",
            "designerOrderAmount": null,
            "amount": 348.72,
            "amountFront": 348.72,
            "poNumber": 4288124,
            "projectNameFront": "ES / Encimera / Vivienda Costa Azul 8 / VML2 / ESTUDIO NOGAL / ARKEM",
            "createdByName": "Integration User",
            "invoiceNumber": null,
            "currencyIsoCode": "EUR",
            "invoiceUrl": null,
            "projectAccountId": "0010X00004ool1AQAQ",
            "projectAccountName": "Arkem Projects SL",
            "projectAccountOwnerLanguage": "es",
            "projectAccountOwnerEmail": "lromero@cosentino.com.invalid",
            "sapBonusAmountInvoice": 0.0,
            "sapBonusAmount": 348.72,
            "sapBonusExpiredDate": "2026-08-04",
            "accountId": "0017T00000Ndp5CQAR",
            "automaticInvoice": false
        },
        {
            "id": "aAzJW0000003rCh0AI",
            "projectId": "0067T000006nLIdQAM",
            "projectName": "FR / Façade / Résidence Lumière 21 / PRT9 / ATELIER VERT / DOMUS",
            "createdDate": "2026-02-19T14:47:02.000+0000",
            "memberName": "paul Garnier",
            "status": "Created_from_SAP",
            "statusLabel": "Created_from_SAP",
            "designerOrderAmount": null,
            "amount": 512.4,
            "amountFront": 512.4,
            "poNumber": 4289450,
            "projectNameFront": "FR / Façade / Résidence Lumière 21 / PRT9 / ATELIER VERT / DOMUS",
            "createdByName": "Integration User",
            "invoiceNumber": null,
            "currencyIsoCode": "EUR",
            "invoiceUrl": null,
            "projectAccountId": "0010X00004ool1BQAQ",
            "projectAccountName": "Domus Renovation SAS",
            "projectAccountOwnerLanguage": "fr",
            "projectAccountOwnerEmail": "pgarnier@cosentino.com.invalid",
            "sapBonusAmountInvoice": 0.0,
            "sapBonusAmount": 512.4,
            "sapBonusExpiredDate": "2026-08-19",
            "accountId": "0017T00000Ndp6CQAR",
            "automaticInvoice": true
        },
        {
            "id": "aAzJW0000003rCi0AI",
            "projectId": "0067T000006nLIeQAM",
            "projectName": "US / Kitchen Tops / Riverstone Loft 3 / MCH7 / NORTH GRID STUDIO / HARBOR",
            "createdDate": "2026-03-03T16:05:41.000+0000",
            "memberName": "amelia Brooks",
            "status": "Created_from_SAP",
            "statusLabel": "Created_from_SAP",
            "designerOrderAmount": null,
            "amount": 689.15,
            "amountFront": 689.15,
            "poNumber": 4291038,
            "projectNameFront": "US / Kitchen Tops / Riverstone Loft 3 / MCH7 / NORTH GRID STUDIO / HARBOR",
            "createdByName": "Integration User",
            "invoiceNumber": null,
            "currencyIsoCode": "USD",
            "invoiceUrl": null,
            "projectAccountId": "0010X00004ool1CQAQ",
            "projectAccountName": "Harbor Living LLC",
            "projectAccountOwnerLanguage": "en",
            "projectAccountOwnerEmail": "abrooks@cosentino.com.invalid",
            "sapBonusAmountInvoice": 0.0,
            "sapBonusAmount": 689.15,
            "sapBonusExpiredDate": "2026-09-03",
            "accountId": "0017T00000Ndp7CQAR",
            "automaticInvoice": false
        },
    ]

    private readonly requestedCommissionsDummyData = {
        items: [
            {
                id: 'a0B1X000001ABC001',
                name: 'DBR-00001',
                bonusAmount: 3250.0,
                requestedDate: '2024-03-15',
                requestedById: '0031X000002XYZ001',
                invoiceNumber: 'INV-2024-001',
                invoiceUrl: 'https://storage.example.com/invoices/INV-2024-001.pdf',
                status: 'Sent_to_SAP',
                statusLabel: 'Sent to SAP',
                currencyIsoCode: 'EUR',
                denyingReason: null,
                createdByName: 'John Designer',
                automaticInvoice: false,
                invoiceDate: '2024-03-16',
                projectName: 'Proyecto Madrid, Proyecto Barcelona, Proyecto Valencia',
                poNumber: 'SAP-001, SAP-002, SAP-003, SAP-004, SAP-005',
                projectDetails: [
                    {
                        projectName: 'Proyecto Madrid',
                        poNumbers: ['SAP-001', 'SAP-002'],
                        bonusAmount: 1500.0,
                    },
                    {
                        projectName: 'Proyecto Barcelona',
                        poNumbers: ['SAP-003', 'SAP-004'],
                        bonusAmount: 1250.0,
                    },
                    {
                        projectName: 'Proyecto Valencia',
                        poNumbers: ['SAP-005'],
                        bonusAmount: 500.0,
                    },
                ],
            },
            {
                id: 'a0B1X000001ABC002',
                name: 'DBR-00002',
                bonusAmount: 4800.0,
                requestedDate: '2024-04-10',
                requestedById: '0031X000002XYZ002',
                invoiceNumber: 'INV-2024-002',
                invoiceUrl: 'https://storage.example.com/invoices/INV-2024-002.pdf',
                status: 'Requested',
                statusLabel: 'Requested',
                currencyIsoCode: 'EUR',
                denyingReason: null,
                createdByName: 'Maria Designer',
                automaticInvoice: true,
                invoiceDate: null,
                projectName: 'Proyecto Sevilla, Proyecto Bilbao',
                poNumber: 'SAP-010, SAP-011, SAP-012, SAP-013',
                projectDetails: [
                    {
                        projectName: 'Proyecto Sevilla',
                        poNumbers: ['SAP-010', 'SAP-011', 'SAP-012'],
                        bonusAmount: 3000.0,
                    },
                    {
                        projectName: 'Proyecto Bilbao',
                        poNumbers: ['SAP-013'],
                        bonusAmount: 1800.0,
                    },
                ],
            },
            {
                id: 'a0B1X000001ABC003',
                name: 'DBR-00003',
                bonusAmount: 950.0,
                requestedDate: '2024-05-01',
                requestedById: '0031X000002XYZ003',
                invoiceNumber: '-',
                invoiceUrl: null,
                status: 'Denied',
                statusLabel: 'Denied',
                currencyIsoCode: 'EUR',
                denyingReason: 'Documentacion incompleta',
                createdByName: 'Carlos Designer',
                automaticInvoice: false,
                invoiceDate: null,
                projectName: 'Proyecto Zaragoza, Proyecto Malaga, Proyecto Murcia',
                poNumber: 'SAP-020, SAP-021, SAP-022, SAP-023, SAP-024, SAP-025',
                projectDetails: [
                    {
                        projectName: 'Proyecto Zaragoza',
                        poNumbers: ['SAP-020', 'SAP-021'],
                        bonusAmount: 400.0,
                    },
                    {
                        projectName: 'Proyecto Malaga',
                        poNumbers: ['SAP-022', 'SAP-023', 'SAP-024'],
                        bonusAmount: 350.0,
                    },
                    {
                        projectName: 'Proyecto Murcia',
                        poNumbers: ['SAP-025'],
                        bonusAmount: 200.0,
                    },
                ],
            },
            {
                id: 'a0B1X000001ABC004',
                name: 'DBR-00004',
                bonusAmount: 2100.0,
                requestedDate: '2024-06-08',
                requestedById: '0031X000002XYZ004',
                invoiceNumber: 'INV-2024-004',
                invoiceUrl: 'https://storage.example.com/invoices/INV-2024-004.pdf',
                status: 'Approved',
                statusLabel: 'Approved',
                currencyIsoCode: 'EUR',
                denyingReason: null,
                createdByName: 'Laura Studio',
                automaticInvoice: false,
                invoiceDate: '2024-06-12',
                projectName: 'Proyecto Lisboa, Proyecto Porto',
                poNumber: 'SAP-030, SAP-031, SAP-032',
                projectDetails: [
                    {
                        projectName: 'Proyecto Lisboa',
                        poNumbers: ['SAP-030', 'SAP-031'],
                        bonusAmount: 1400.0,
                    },
                    {
                        projectName: 'Proyecto Porto',
                        poNumbers: ['SAP-032'],
                        bonusAmount: 700.0,
                    },
                ],
            },
            {
                id: 'a0B1X000001ABC005',
                name: 'DBR-00005',
                bonusAmount: 1750.0,
                requestedDate: '2024-07-02',
                requestedById: '0031X000002XYZ005',
                invoiceNumber: 'INV-2024-005',
                invoiceUrl: 'https://storage.example.com/invoices/INV-2024-005.pdf',
                status: 'Paid',
                statusLabel: 'Paid',
                currencyIsoCode: 'EUR',
                denyingReason: null,
                createdByName: 'Nora Interiors',
                automaticInvoice: true,
                invoiceDate: '2024-07-06',
                projectName: 'Proyecto Milan',
                poNumber: 'SAP-040, SAP-041',
                projectDetails: [
                    {
                        projectName: 'Proyecto Milan',
                        poNumbers: ['SAP-040', 'SAP-041'],
                        bonusAmount: 1750.0,
                    },
                ],
            },
        ],
    }

    private getLocaleByCountry(country: string): string {
        // Países que usan formato americano (coma miles, punto decimal): 23,306.24
        const americanFormatCountries = ['US', 'GB', 'AU', 'CA', 'IE', 'NZ', 'ZA', 'IN', 'PH', 'MY', 'SG', 'HK', 'TW', 'KR', 'JP', 'CN', 'TH', 'ID', 'VN']

        if (americanFormatCountries.includes(country)) {
            return 'en-US'
        }
        // Por defecto formato europeo (punto miles, coma decimal): 23.306,24
        return 'de-DE'
    }

    formatAmount(value: number): string {
        const locale = this.getLocaleByCountry(this.userInfo?.country || '')
        return new Intl.NumberFormat(locale, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value)
    }

    ngOnInit() {
        this.api.userInfo.subscribe((userInfo) => (this.userInfo = userInfo))
        this.loadCommissions()
    }

    loadCommissions() {
        this.api.getPendingCommissions().subscribe({
            next: (response) => {
                const pendingItems = Array.isArray(response?.items) ? response.items : (Array.isArray(response) ? response : [])

                this.pendingCommissionsOriginalData = pendingItems
                this.syncSelectedInvoiceTypeWithAvailableData()
                this.pendingCommissionsFilteredData = this.getMappedPendingCommissions(this.selectedInvoiceType)
                this.totalPendingAmount = this.pendingCommissionsOriginalData.reduce((sum, item) => sum + (item?.amount || 0), 0)

                if (this.tab === 'TO_REQUEST') {
                    this.applyPagination()
                }
            },
            error: (error: any) => console.log(error),
        })

        this.api.getRequestedCommissions().subscribe({
            next: (response) => {
                const requestedItems = Array.isArray(response?.items) ? response.items : (Array.isArray(response) ? response : [])

                this.requestedCommissionsOriginalData = requestedItems
                this.requestedCommissionsMappedData = requestedItems.map((item: any) => ({
                    id: item.id,
                    status: item.status,
                    statusLabel: item.statusLabel,
                    projectName: item.projectName,
                    poNumber: item.poNumber,
                    requestedDate: item.requestedDate,
                    memberName: item.createdByName,
                    amount: this.formatAmount(item.bonusAmount) + ' ' + this.currencyService.getCurrencySymbol(item.currencyIsoCode),
                    invoiceUrl: item.invoiceUrl,
                    currencyIsoCode: item.currencyIsoCode,
                    projectDetails: (item.projectDetails || []).map((detail: any) => ({
                        projectName: detail.projectName,
                        poNumbers: detail.poNumbers || [],
                        bonusAmount: detail.bonusAmount,
                    })),
                }))

                if (this.tab === 'REQUESTED') {
                    this.applyPagination()
                }
            },
            error: (error: any) => console.log(error),
        })
    }
    filterCommissions(tab: string) {
        // No permitir ir a REQUESTING sin comisiones seleccionadas
        if (tab === 'REQUESTING' && this.selectedCommissions.length === 0) {
            return
        }
        this.tab = tab
        if (tab === 'TO_REQUEST' || tab === 'REQUESTED') {
            this.selectedCommissions = []
            this.currentPage = 0
            this.applyPagination()
        }
    }
    onPageChange(page: number) {
        this.currentPage = page
        this.applyPagination()
    }
    getAmountSumOfSelectedCommissions(): string {
        const total = this.selectedCommissions.reduce((sum, commission) => {
            return sum + commission.amount
        }, 0)
        return this.formatAmount(total)
    }
    getRawAmountSumOfSelectedCommissions(): number {
        return this.selectedCommissions.reduce((sum, commission) => {
            return sum + commission.amount
        }, 0)
    }
    getAmountSumOfRequestedCommissions(): string {
        const total = this.requestedCommissionsOriginalData.reduce((sum, commission) => {
            return sum + commission.bonusAmount
        }, 0)
        return this.formatAmount(total)
    }
    getCoinOfCommissionsPending() {
        if (this.pendingCommissionsOriginalData.length > 0) {
            return this.currencyService.getCurrencySymbol(this.pendingCommissionsOriginalData[0].currencyIsoCode)
        } else if (this.requestedCommissionsOriginalData.length > 0) {
            return this.currencyService.getCurrencySymbol(this.requestedCommissionsOriginalData[0].currencyIsoCode)
        }
        return ''
    }
    getCoinOfCommissionsRequest() {
        if (this.pendingCommissionsOriginalData.length > 0) {
            return this.pendingCommissionsOriginalData[0].currencyIsoCode
        } else if (this.requestedCommissionsOriginalData.length > 0) {
            return this.requestedCommissionsOriginalData[0].currencyIsoCode
        }
        return ''
    }
    get manualInvoiceProjectsWithReferences(): { projectName: string; references: string }[] {
        const projectsMap = new Map<string, Set<string>>()

        this.selectedCommissions.forEach((commission) => {
            const projectName = commission?.projectName || '-'
            const reference = commission?.poNumber

            if (!projectsMap.has(projectName)) {
                projectsMap.set(projectName, new Set<string>())
            }

            if (reference) {
                projectsMap.get(projectName)?.add(reference)
            }
        })

        return Array.from(projectsMap.entries()).map(([projectName, references]) => ({
            projectName,
            references: Array.from(references).join(', ') || '-',
        }))
    }

    get automaticInvoiceIncludedProjects(): string {
        const uniqueProjectNames = Array.from(
            new Set(
                this.selectedCommissions
                    .map((commission) => commission?.projectName)
                    .filter((projectName) => !!projectName)
            )
        )

        return uniqueProjectNames.join(', ') || '-'
    }

    get hasBothInvoiceTypes(): boolean {
        const hasAutomatic = this.pendingCommissionsOriginalData.some(item => item.automaticInvoice === true)
        const hasManual = this.pendingCommissionsOriginalData.some(item => item.automaticInvoice === false)
        return hasAutomatic && hasManual
    }

    get isUsOrCaCountry(): boolean {
        const country = (this.userInfo?.country || '').toUpperCase()
        return country === 'US' || country === 'CA'
    }

    selectCommission(selectedItems: any[]) {
        //busca por id en el json original y luego mete el objeto completo
        this.selectedCommissions = selectedItems.map((selected) => {
            return this.pendingCommissionsOriginalData.find((commission) => commission.id === selected.id)
        })
        console.log(this.selectedCommissions)
    }

    isPendingCommissionSelected(row: any): boolean {
        return !!row?.id && this.selectedCommissions.some((commission) => commission?.id === row.id)
    }

    onPendingCommissionSelectionChange(row: any, checked: boolean) {
        if (!row?.id) {
            return
        }

        const selectedCommission = this.pendingCommissionsOriginalData.find((commission) => commission.id === row.id)
        if (!selectedCommission) {
            return
        }

        if (checked) {
            if (!this.selectedCommissions.some((commission) => commission?.id === row.id)) {
                this.selectedCommissions = [...this.selectedCommissions, selectedCommission]
            }
            return
        }

        this.selectedCommissions = this.selectedCommissions.filter((commission) => commission?.id !== row.id)
    }

    togglePendingCommissionDetails(row: any) {
        if (!row?.id) {
            return
        }

        if (this.expandedPendingCommissionIds.has(row.id)) {
            this.expandedPendingCommissionIds.delete(row.id)
            return
        }

        this.expandedPendingCommissionIds.add(row.id)
    }

    isPendingCommissionExpanded(row: any): boolean {
        return !!row?.id && this.expandedPendingCommissionIds.has(row.id)
    }
    requestCommissions() {
        this.lastRequestedInvoiceType = this.selectedInvoiceType
        this.api.requestCommissions(this.selectedCommissions.map(c => c.id),String(this.getRawAmountSumOfSelectedCommissions()), this.getCoinOfCommissionsRequest()).subscribe({
            next: (response) => {
                this.selectedCommissions = []
                this.tab = 'TO_REQUEST'
                this.loadCommissions()
                this.isRequestResultModalOpen = true
            },
            error: (error: any) => console.log(error),
        })
    }

    closeRequestResultModal() {
        this.isRequestResultModalOpen = false
    }

    get requestResultModalTitle(): string {
        if (this.lastRequestedInvoiceType === 'MANUAL_INVOICE') {
            return this.translateService.instant('commissions.request_modal_manual_title')
        }
        return this.translateService.instant('commissions.request_modal_automatic_title')
    }

    get requestResultModalMessage(): string {
        if (this.lastRequestedInvoiceType === 'MANUAL_INVOICE') {
            if (this.isUsOrCaCountry) {
                return this.translateService.instant('commissions.request_modal_manual_message_us_ca')
            }
            return this.translateService.instant('commissions.request_modal_manual_message')
        }
        return this.translateService.instant('commissions.request_modal_automatic_message')
    }
    onApplicationFilter($event: SelectValue | null) {
        if ($event) {
            this.selectedValue = $event
            this.selectedInvoiceType = $event.id as 'AUTOMATIC_INVOICE' | 'MANUAL_INVOICE'
            this.pendingCommissionsFilteredData = this.getMappedPendingCommissions(this.selectedInvoiceType)

            this.currentPage = 0
            this.applyPagination()
        }
    }

    private getMappedPendingCommissions(invoiceType: 'AUTOMATIC_INVOICE' | 'MANUAL_INVOICE' | null): any[] {
        return this.pendingCommissionsOriginalData
            .filter((item) => {
                if (invoiceType === 'AUTOMATIC_INVOICE') {
                    return item.automaticInvoice === true
                }

                if (invoiceType === 'MANUAL_INVOICE') {
                    return item.automaticInvoice === false
                }

                return true
            })
            .map((item: any) => ({
                id: item.id,
                projectName: item.projectName,
                poNumber: item.poNumber,
                sapBonusExpiredDate: item.sapBonusExpiredDate,
                memberName: item.memberName,
                amount: this.formatAmount(item.amount) + ' ' + this.currencyService.getCurrencySymbol(item.currencyIsoCode),
                automaticInvoice: item.automaticInvoice,
            }))
    }

    private syncSelectedInvoiceTypeWithAvailableData() {
        const hasAutomatic = this.pendingCommissionsOriginalData.some((item) => item.automaticInvoice === true)
        const hasManual = this.pendingCommissionsOriginalData.some((item) => item.automaticInvoice === false)

        if (hasManual && !hasAutomatic) {
            this.selectedInvoiceType = 'MANUAL_INVOICE'
        } else if (hasAutomatic && !hasManual) {
            this.selectedInvoiceType = 'AUTOMATIC_INVOICE'
        }

        const selectedOption = this.availableTypes.find((option) => option.id === this.selectedInvoiceType)
        this.selectedValue = selectedOption || this.availableTypes[0]
    }

    get shouldShowPagination(): boolean {
        return this.totalPages > 1 && (this.tab === 'TO_REQUEST' || this.tab === 'REQUESTED')
    }

    toggleRequestedCommissionDetails(row: RequestedCommissionRow) {
        if (!row?.id) {
            return
        }

        if (this.expandedRequestedCommissionIds.has(row.id)) {
            this.expandedRequestedCommissionIds.delete(row.id)
            return
        }

        this.expandedRequestedCommissionIds.add(row.id)
    }

    isRequestedCommissionExpanded(row: RequestedCommissionRow): boolean {
        return !!row?.id && this.expandedRequestedCommissionIds.has(row.id)
    }

    getRequestedCommissionStatusLabel(row: RequestedCommissionRow): string {
        return row.statusLabel || this.getStatusTranslation(row.status)
    }

    getRequestedCommissionStatusStyle(status: string): { backgroundColor: string; color: string } {
        const normalizedStatus = (status || '').toLowerCase()

        if (normalizedStatus === 'approved') {
            return { backgroundColor: '#DCFCE7', color: '#15803D' }
        }

        if (normalizedStatus === 'denied') {
            return { backgroundColor: '#FEE2E2', color: '#B91C1C' }
        }

        if (normalizedStatus === 'paid') {
            return { backgroundColor: '#DBEAFE', color: '#1D4ED8' }
        }

        return { backgroundColor: '#E5E7EB', color: '#374151' }
    }

    getRequestedCommissionProjectDetails(row: RequestedCommissionRow): RequestedCommissionProjectDetail[] {
        if (row.projectDetails?.length) {
            return row.projectDetails
        }

        return [
            {
                projectName: row.projectName,
                poNumbers: row.poNumber ? row.poNumber.split(',').map((poNumber) => poNumber.trim()).filter(Boolean) : [],
                bonusAmount: this.requestedCommissionsOriginalData.find((item) => item.id === row.id)?.bonusAmount || 0,
            },
        ]
    }

    getProjectDetailReferences(projectDetail: RequestedCommissionProjectDetail): string {
        return (projectDetail.poNumbers || []).join(', ')
    }

    getProjectDetailAmount(projectDetail: RequestedCommissionProjectDetail, currencyIsoCode: string): string {
        return this.formatAmount(projectDetail.bonusAmount) + ' ' + this.currencyService.getCurrencySymbol(currencyIsoCode)
    }

    private applyPagination() {
        const data = this.tab === 'TO_REQUEST' ? this.pendingCommissionsFilteredData : this.requestedCommissionsMappedData
        const safeData = data || []

        this.totalPages = Math.ceil(safeData.length / this.pageSize)

        if (this.totalPages <= 1) {
            this.currentPage = 0
            if (this.tab === 'TO_REQUEST') {
                this.pendingCommissionsData = safeData
            } else if (this.tab === 'REQUESTED') {
                this.requestedCommissionsData = safeData
            }
            return
        }

        const safePage = Math.min(this.currentPage, this.totalPages - 1)
        if (safePage !== this.currentPage) {
            this.currentPage = safePage
        }

        const start = safePage * this.pageSize
        const end = start + this.pageSize

        if (this.tab === 'TO_REQUEST') {
            this.pendingCommissionsData = safeData.slice(start, end)
        } else if (this.tab === 'REQUESTED') {
            this.requestedCommissionsData = safeData.slice(start, end)
        }
    }

    protected readonly AccountType = AccountType

    private getStatusTranslation(status: string): string {
        const statusMap: { [key: string]: string } = {
            'Requested': 'commissions.requested',
            'Approved': 'my_claims.approved',
            'Denied': 'my_claims.denied',
            'Paid': 'commissions.paid',
            'Sent_to_SAP': 'commissions.sent_to_sap'
        }
        return this.translateService.instant(statusMap[status] || status)
    }
}
